import { Component, Input, ViewChild } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatMenuModule } from "@angular/material/menu";
import { MAT_MENU_DEFAULT_OPTIONS, MatMenu } from '@angular/material/menu';
import { MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogModule, MatDialog, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { ExternalScreenModalComponent } from '../../external-screen-modal/external-screen-modal.component';
import { OverlayContainer } from '@angular/cdk/overlay';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../auth/auth.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import {VALUE_TO_CHECK_ORDER_MANAGEMENT} from '../../constants/app.constants';

@Component({
  standalone: true,
  imports: [RouterModule, CommonModule, MatToolbarModule, 
    MatIconModule,   
    MatButtonModule,
    MatInputModule,   
    MatSelectModule,  
    MatFormFieldModule,
    MatMenuModule, MatDialogModule, MatDialogTitle, MatDialogContent, MatDialogActions, TranslateModule],
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  
  animations: [
    trigger('menuAnimation', [
      state('void', style({ opacity: 0, transform: 'scale(1)' })),
      state('*', style({ opacity: 1, transform: 'scale(1)' })),
      transition('void => *', animate('1000ms ease-out')),
      transition('* => void', animate('0ms ease-in'))
    ])
  ],
  providers: [
    {
      provide: MAT_MENU_DEFAULT_OPTIONS,
      useValue: { overlayPanelClass: 'cnPopoverContainer' }
    },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: { overlayPanelClass: 'externalLinkContainer' }
    }
  ]
})
export class HeaderComponent {
  @ViewChild(MatMenu, {static: true}) subMenu!: MatMenu;
  userName: any;
  @Input() userDetails: any;
  isOrderTabEnabled: boolean = false;
  valueToCheck = `${VALUE_TO_CHECK_ORDER_MANAGEMENT}`;
  constructor(private router: Router, public dialog: MatDialog, public authService: AuthService, private localizationService: TranslateService) {
  }

  ngOnInit() {
    const queryParams = new URLSearchParams(window.location.search);
    let lang = queryParams.get('lang')?? 'en';
    sessionStorage.setItem('langKey',lang)
    this.localizationService.setDefaultLang(lang);
    queueMicrotask(() => {
      const group = this.userDetails?.firebase?.sign_in_attributes?.groups;
      this.isOrderTabEnabled = group?.includes(this.valueToCheck);
      this.userName = this.userDetails?.firebase?.identities?.['oidc.isamqa']?.[0];
    });     
  }

  onAccountMenu() {
    const menuTriggers = document.querySelectorAll('.mat-mdc-menu-trigger');
    menuTriggers.forEach(triggerButton => {
      const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {          
          if (mutation.attributeName === 'aria-expanded') {
            const isExpanded = triggerButton.getAttribute('aria-expanded') === 'true';
            if (isExpanded) {
              triggerButton.classList.add('menu-expanded-active');
            } else {
              triggerButton.classList.remove('menu-expanded-active');
            }
          } 
        })
      });      
      observer.observe(triggerButton, {
        attributes: true,
        attributeFilter: ['aria-expanded']
      });  
    });
  }

   /**
   * Navigates to the orders page with a specific URL to be loaded in an iframe.
   * This method should be called when the "Create an order" button is clicked.
   */
  navigateToCreateOrder(): void {
    const createOrderUrl = 'https://ship-stg.web.cn.ca/create-order';
    this.router.navigate(['/orders'], { queryParams: { iframeUrl: createOrderUrl } });
  }
  
  openExternalScreen(menu: any) {    
    let iframeUrl: string;

    switch (menu) {
      case 'profile':
        iframeUrl = 'https://ecenv.cn.ca/Customer/english/CustomerProfileUpdateProfile_ProfileUpdate';
        break;
      case 'support':
        iframeUrl = 'https://ecenv.cn.ca/velocity/service/servicehome?lang=EN';
        break;
      case 'contact':
        iframeUrl = 'https://ecenv.cn.ca/velocity/service/serviceRequest.html';
        break;
      default: 
        iframeUrl = 'https://ecenv.cn.ca/Customer/english/CustomerProfileUpdateProfile_ProfileUpdate';  
        break
    }

    const dialogRef: MatDialogRef<ExternalScreenModalComponent, any> = this.dialog.open(ExternalScreenModalComponent, {
      data: { iframeUrl },
      panelClass: 'externalLinkContainer'
    });

    dialogRef.afterClosed().subscribe((res) => {
      // Handle dialog close if needed
    });
  }  

  async logout() {
    await this.authService.signOut();
    window.location.href = 'https://ecenv.cn.ca/cis/#/auth?logout=true';
  }
}
